if (!window.variantCardsFallback) {
  window.variantCardsFallback = true;

  // Picking a card whose combination doesn't exist moves the other options to the closest real plan.
  // Runs in the capture phase so VariantSelects reads the corrected selection.
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.dataset.fallbackOptionValueIds) return;

      const picker = input.closest('variant-selects');
      if (!picker) return;

      input.dataset.fallbackOptionValueIds
        .split(',')
        .filter(Boolean)
        .forEach((id) => {
          const match = picker.querySelector(`input[data-option-value-id="${id}"]`);
          if (match) match.checked = true;
        });
    },
    true
  );

  // Dawn reports plan changes with the product page's section id, even inside the quick-add pop-up,
  // whose copy of the section is prefixed "quickadd-". Prefer the open pop-up's copy when there is one.
  const resolveSection = (sectionId) =>
    document.querySelector(`quick-add-modal[open] [data-section="quickadd-${sectionId}"]`)
      ? `quickadd-${sectionId}`
      : sectionId;

  // When a plan change moves the price, the new price (and the sticky bar's) settles in from a soft blur,
  // so the shopper sees what the change costs. Unchanged prices stay still.
  const watchPrice = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const sectionId = resolveSection(data.sectionId);
      const price = document.getElementById(`price-${sectionId}`);
      if (!price) return;
      const text = price.innerText.trim();
      if (price.dataset.lastPrice === undefined || price.dataset.lastPrice === text) {
        price.dataset.lastPrice = text;
        return;
      }
      price.dataset.lastPrice = text;

      const targets = [
        price,
        document.getElementById(`StickyBuy-${sectionId}`),
        document.getElementById(`BuyNowPrice-${sectionId}`),
      ].filter(Boolean);
      // Apply the blurred state, force a style flush, then release it so the transition always runs and never sticks.
      targets.forEach((el) => el.classList.add('is-updating'));
      void price.offsetWidth;
      targets.forEach((el) => el.classList.remove('is-updating'));
    });
    document.querySelectorAll('[id^="price-"]').forEach((price) => {
      price.dataset.lastPrice = price.innerText.trim();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchPrice);
  } else {
    watchPrice();
  }

  // "Save" badge (snippets/variant-card-savings.liquid). When the buyer picks a pack, the picker is
  // re-rendered with the badge on the next better-value pack; the badge glides there from where it
  // was, so the eye follows it up to the bigger pack, and its text becomes the "more here" version.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lastBadge = new Map();

  // Keep the badge inside the option group, so it never hangs off the screen edge on phones.
  const keepInside = (badge) => {
    const bounds = badge.closest('.product-form__input');
    if (!bounds) return;
    badge.style.setProperty('--save-shift', '0px');
    const area = bounds.getBoundingClientRect();
    const rect = badge.getBoundingClientRect();
    let shift = 0;
    if (rect.left < area.left) shift = area.left - rect.left;
    else if (rect.right > area.right) shift = area.right - rect.right;
    badge.style.setProperty('--save-shift', `${Math.round(shift)}px`);
  };

  const keepAllInside = () => document.querySelectorAll('.variant-card__save').forEach(keepInside);

  document.addEventListener(
    'change',
    (event) => {
      const picker = event.target.closest?.('variant-selects');
      const badge = picker?.querySelector('.variant-card__save');
      if (picker && badge) lastBadge.set(picker.dataset.section, badge.getBoundingClientRect());
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      setTimeout(() => {
        const sectionId = resolveSection(data.sectionId);
        const picker = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
        const badge = picker?.querySelector('.variant-card__save');
        const from = lastBadge.get(sectionId);
        lastBadge.delete(sectionId);
        if (!badge) return;

        if (badge.dataset.saveMore) badge.textContent = badge.dataset.saveMore;
        keepInside(badge);
        if (reduceMotion.matches) return;

        if (!from) {
          badge.animate([{ opacity: 0, scale: '0.9' }, { opacity: 1, scale: '1' }], {
            duration: 200,
            easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
          });
          return;
        }
        const to = badge.getBoundingClientRect();
        const dx = from.left + from.width / 2 - (to.left + to.width / 2);
        const dy = from.top - to.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
        badge.animate([{ translate: `${dx}px ${dy}px` }, { translate: '0 0' }], {
          duration: 320,
          easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
        });
      }, 0);
    });
  }

  window.addEventListener('resize', keepAllInside, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', keepAllInside);
  } else {
    keepAllInside();
  }
}
